module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAfCAMAAACmqq93AAAAaVBMVEUAAAD5iAP5iAP5iAP5iAP5iAP5iAP5iAP5iAP5iAP5iAP5iAP5iAP5iAP5iAP5iAP5iAP5iAP5iAP5iAP5iAP5iAP5iAP5iAP5iAP5iAP5iAP5iAP5iAP5iAP5iAP5iAP5iAP5iAP5iAOQQAv/AAAAInRSTlMABQqyiXq+oJf2pmXn29DBJxwTjkQzIfDv3cReVBK5kEI1+ev3qAAAAMpJREFUOMvd0VkOgzAMRdGaEiDM80yHt/9FNqoqixDTBXC/8nGUWPHtypHCeYr2tKhXDTm91sWeIiu7VJTpu8xgUYxtlQsyr14jbGpKvLsj716i4VL41BxkQz5woHwHK35HpmaydmA48PQSRdqV0+848Z/IFLqv5+9hrnuNv1R5C4UAQko8JVOWgVEKyviArUR9I4Fi67cCMNaXKUsgWzKArbyCB+yCkxU8SVgsNQKNWNo2cihL19rUyBg4sxYNWbrFFO4pS9nertwHm/RIWp1pp/QAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/join_us/mail.png
// module id = 91
// module chunks = 1